module.exports = __webpack_public_path__ + "static/media/SiobhanHokin.3935005d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/SiobhanHokin.pdf
// module id = 37
// module chunks = 0